import React, { useState } from 'react';
import Index from '../OiForm/OiFormInput';

import OiButton from '../Common/OiButton/OiButton';
import { isEmpty, isPasswordMatch, isPasswordValid, isValidLength } from '../../helpers/validate';
import { useDispatch } from 'react-redux';
import { setError, setProcessLoading, setUpdatePasswordError, updatePassword } from '../../../store/action';
import ErrorPicker from '../Error';

const ForgotPassword = props => {
    const dispatch = useDispatch();
    const [state, setState] = useState({
        passwordType: {
            curPasVis: false,
            newPasVis: false,
            conPasVis: false
        },

        validate: {
            oldPassword: '',
            newPassword: '',
            confirmPassword: ''
        },

        errors: {}
    });
    const validates = () => {
        const { oldPassword, newPassword, confirmPassword } = state.validate;
        const errors = {};
        if (isValidLength(oldPassword, 3)) errors.oldPassword = isValidLength(oldPassword, 3);
        if (isEmpty(newPassword) || isPasswordValid(newPassword) || isValidLength(newPassword, 8))
            errors.newPassword = isPasswordValid(newPassword);
        if (isEmpty(confirmPassword) || isPasswordMatch(newPassword, confirmPassword))
            errors.confirmPassword = isPasswordMatch(newPassword, confirmPassword);
        return Object.keys(errors).length === 0 ? null : errors;
    };
    const validateProperty = ({ target }) => {
        const { name, value } = target;
        if (name === 'oldPassword') return isEmpty(value) || isValidLength(value, 3);
        if (name === 'newPassword') return isEmpty(value) || isPasswordValid(value) || isValidLength(value, 8);
        if (name === 'confirmPassword') return isEmpty(value) || isPasswordMatch(state.validate.newPassword, value);
    };
    const handleChange = event => {
        const { name, value } = event.target;

        const errors = { ...state.errors };
        const errorMessage = validateProperty(event);
        if (errorMessage) {
            errors[name] = errorMessage;
        } else {
            delete errors[name];
        }

        // -- Validation -->
        const validate = { ...state.validate };
        validate[name] = value;

        setState({ ...state, validate, errors });
    };
    // const handlePasswordChange = name => {
    //     const passwordType = { ...state.passwordType };

    //     passwordType[name] = !passwordType[name];
    //     setState({ ...state, passwordType });
    // };
    const handleSubmit = event => {
        event.preventDefault();

        const value = state.validate;
        // props.setUpdatePasswordError('');
        dispatch(setUpdatePasswordError(''));
        dispatch(setProcessLoading(true));
        dispatch(updatePassword(value));
        dispatch(setError(''));

        // this.props.handlePasswordVisibility(!this.props.changePassword)
    };

    const { error, processing } = props;
    const {
        validate,
        // passwordType: { curPasVis, newPasVis, conPasVis },
        errors
    } = state;
    return (
        <React.Fragment>
            <h2 className="settings__header u-half-gradient-bg">Change Password</h2>

            <form className="oi-form" onSubmit={handleSubmit}>
                <div className="oi-form__section  u-margin-top-3_5">
                    <div className="oi-form__group">
                        <div className="oi-form__associate u-margin-top-switch ">
                            <Index
                                labelClass="oi-form__label-primary"
                                inputClass="oi-form__input-primary  u-placeholder-max  oi-form__reset-password oi-form__input--height4"
                                name="oldPassword"
                                type="password"
                                label="Current Password"
                                hook="current-password"
                                onChange={handleChange}
                                placeholder="* * * * * * * * * * *"
                                inputValue={validate['oldPassword']}
                                auto="new-password"
                                error={errors.oldPassword}
                                passwordVisibility={true}
                            />
                        </div>
                    </div>

                    <div className="oi-form__group">
                        <div className="oi-form__associate u-margin-top-switch ">
                            <Index
                                labelClass="oi-form__label-primary"
                                inputClass="oi-form__input-primary  u-placeholder-max  oi-form__reset-password oi-form__input--height4"
                                name="newPassword"
                                type="password"
                                label="New Password"
                                hook="new-password"
                                onChange={handleChange}
                                placeholder="* * * * * * * * * * *"
                                inputValue={validate['newPassword']}
                                auto="new-password"
                                error={errors.newPassword}
                                passwordVisibility={true}
                            />
                        </div>
                    </div>

                    <div className="oi-form__group">
                        <div className="oi-form__associate u-margin-top-switch ">
                            <Index
                                labelClass="oi-form__label-primary"
                                inputClass="oi-form__input-primary  u-placeholder-max  oi-form__reset-password oi-form__input--height4"
                                name="confirmPassword"
                                type="password"
                                label="Confirm Password"
                                hook="confirm-password"
                                onChange={handleChange}
                                placeholder="* * * * * * * * * * *"
                                inputValue={validate['confirmPassword']}
                                auto="new-password"
                                error={errors.confirmPassword}
                                passwordVisibility={true}
                            />
                        </div>
                    </div>
                </div>

                <div className="u-margin-top-3_5">
                    <ErrorPicker error={error} />
                    <OiButton
                        disabled={validates()}
                        buttonLoader={processing}
                        styles="oi-btn oi-btn--primary oi-btn--stretch oi-btn--radius5 oi-btn--height45 | u-font14sb"
                        type="submit">
                        Submit
                    </OiButton>
                </div>
            </form>
        </React.Fragment>
    );
};

export default ForgotPassword;
